/**
 * Community — the "coming soon" half of the Social split.
 *
 * Renders the friendly, opt-in community-space copy that previously
 * lived on `/social`. This is the placeholder page — no live content,
 * no widget, no DB. Ships as a hero band so the copy is easy to
 * discover and self-documents the roadmap ("launching with our
 * first neighborhoods").
 *
 * Route: /social/community.
 *
 * Scope guardrail: this page does NOT preempt the full social-
 * platform deliverable described in
 * `/app/memory/social_step0_investigation.md` (3 new DB collections,
 * UGC posts, moderation pipeline, object-storage avatars). When that
 * platform ships, this page becomes the entry point for the live
 * community feed.
 */
import React from "react";
import PublicPageShell from "@/components/PublicPageShell";
import { COMMUNITY_HERO } from "@/content/social";

export default function Community() {
  return (
    <PublicPageShell>
      <section
        data-testid="community-hero-section"
        aria-labelledby="community-hero-headline"
      >
        <div className="pp-wrap py-12 md:py-20 text-center">
          <span className="pp-eyebrow" data-testid="community-hero-eyebrow">
            <span className="dot" />
            {COMMUNITY_HERO.eyebrow}
          </span>
          <h1
            id="community-hero-headline"
            className="pp-h1 mt-6 mx-auto max-w-3xl"
            data-testid="community-hero-headline"
          >
            {COMMUNITY_HERO.headline}
          </h1>
          <p
            className="pp-sub mt-5 mx-auto max-w-2xl"
            data-testid="community-hero-intro"
          >
            {COMMUNITY_HERO.intro}
          </p>
        </div>
      </section>
    </PublicPageShell>
  );
}
